import React from 'react';
import GrayShadowBox from '../../GrayShadowBox';
import Button from '../../Button';

const ProductVendorDatePicker = ({ 
    selectedVendor,
    arrivalDate,
    shipmentDate,
    onVendorChange,
    onArrivalDateChange,
    onShipmentDateChange,
    onSave
}) => {
    // 도착일 변경 핸들러
    const handleArrivalDateChange = (field, value) => {
        const newArrivalDate = {
            ...arrivalDate,
            [field]: value
        };
        
        // 시작일이 변경되고 종료일이 시작일보다 이전이면 종료일 초기화
        if (field === 'start' && newArrivalDate.end && newArrivalDate.end < value) {
            newArrivalDate.end = '';
        }
        
        if (onArrivalDateChange) {
            onArrivalDateChange(newArrivalDate);
        }
    };

    // 출하일 변경 핸들러
    const handleShipmentDateChange = (field, value) => {
        const newShipmentDate = {
            ...shipmentDate,
            [field]: value
        };
        
        // 시작일이 변경되고 종료일이 시작일보다 이전이면 종료일 초기화
        if (field === 'start' && newShipmentDate.end && newShipmentDate.end < value) {
            newShipmentDate.end = '';
        }
        
        if (onShipmentDateChange) {
            onShipmentDateChange(newShipmentDate);
        }
    };

    // 날짜 포맷팅 함수
    const formatDateForDisplay = (dateString) => {
        if (!dateString) return '';
        try {
            return new Date(dateString).toLocaleDateString('ko-KR');
        } catch {
            return dateString;
        }
    };

    return (
        <GrayShadowBox>
            <div className="space-y-6">
                {/* 벤더 선택 */}
                <div>
                    <h3 className="text-lg font-medium text-gray-700 mb-3">벤더 선택</h3>
                    <select
                        value={selectedVendor}
                        onChange={(e) => onVendorChange(e.target.value)}
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="">벤더를 선택하세요</option>
                        <option value="BACK-ORDER">백오더</option>
                        <option value="pre-order">프리오더</option>
                        <option value="hallyu19">한류19</option>
                        <option value="OliveYoung">올리브영</option>
                        <option value="Daiso">다이소</option>
                    </select>
                </div>

                {/* 도착일 및 출하일 피커 - 벤더가 "pre-order"일 때만 표시 */}
                {selectedVendor === 'pre-order' && (
                    <div>
                        {/* <h3 className="text-lg font-semibold text-gray-800 mb-4">프리오더 도착일 및 출하일</h3> */}
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* 도착일 섹션 */}
                            <div className="space-y-4">
                                <h4 className="text-md font-medium text-gray-700">도착일 Arrival Date</h4>
                                
                                <div className="space-y-3">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-600 mb-1">
                                            시작일
                                        </label>
                                        <input
                                            type="date"
                                            value={arrivalDate.start || ''}
                                            onChange={(e) => handleArrivalDateChange('start', e.target.value)}
                                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                        {arrivalDate.start && (
                                            <p className="text-xs text-gray-500 mt-1">
                                                {formatDateForDisplay(arrivalDate.start)}
                                            </p>
                                        )}
                                    </div>
                                    
                                    <div>
                                        <label className="block text-sm font-medium text-gray-600 mb-1">
                                            종료일
                                        </label>
                                        <input
                                            type="date"
                                            value={arrivalDate.end || ''}
                                            min={arrivalDate.start || ''}
                                            onChange={(e) => handleArrivalDateChange('end', e.target.value)}
                                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                        {arrivalDate.end && (
                                            <p className="text-xs text-gray-500 mt-1">
                                                {formatDateForDisplay(arrivalDate.end)}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                
                                {/* 도착일 요약 */}
                                {(arrivalDate.start || arrivalDate.end) && (
                                    <div className="bg-blue-50 rounded-lg p-3">
                                        <p className="text-sm text-blue-800">
                                            <span className="font-medium">도착 예정:</span>{' '}
                                            {arrivalDate.start && arrivalDate.end 
                                                ? `${formatDateForDisplay(arrivalDate.start)} ~ ${formatDateForDisplay(arrivalDate.end)}`
                                                : arrivalDate.start 
                                                    ? `${formatDateForDisplay(arrivalDate.start)}부터`
                                                    : `${formatDateForDisplay(arrivalDate.end)}까지`
                                            }
                                        </p>
                                    </div>
                                )}
                            </div>

                            {/* 출하일 섹션 */}
                            <div className="space-y-4">
                                <h4 className="text-md font-medium text-gray-700">출하일 Shipment Date</h4>
                                
                                <div className="space-y-3">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-600 mb-1">
                                            시작일
                                        </label>
                                        <input
                                            type="date"
                                            value={shipmentDate.start || ''}
                                            onChange={(e) => handleShipmentDateChange('start', e.target.value)}
                                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                                        />
                                        {shipmentDate.start && (
                                            <p className="text-xs text-gray-500 mt-1">
                                                {formatDateForDisplay(shipmentDate.start)}
                                            </p>
                                        )}
                                    </div>
                                    
                                    <div>
                                        <label className="block text-sm font-medium text-gray-600 mb-1">
                                            종료일
                                        </label>
                                        <input
                                            type="date"
                                            value={shipmentDate.end || ''}
                                            min={shipmentDate.start || ''}
                                            onChange={(e) => handleShipmentDateChange('end', e.target.value)}
                                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                                        />
                                        {shipmentDate.end && (
                                            <p className="text-xs text-gray-500 mt-1">
                                                {formatDateForDisplay(shipmentDate.end)}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                
                                {/* 출하일 요약 */}
                                {(shipmentDate.start || shipmentDate.end) && (
                                    <div className="bg-green-50 rounded-lg p-3">
                                        <p className="text-sm text-green-800">
                                            <span className="font-medium">출하 예정:</span>{' '}
                                            {shipmentDate.start && shipmentDate.end 
                                                ? `${formatDateForDisplay(shipmentDate.start)} ~ ${formatDateForDisplay(shipmentDate.end)}`
                                                : shipmentDate.start 
                                                    ? `${formatDateForDisplay(shipmentDate.start)}부터`
                                                    : `${formatDateForDisplay(shipmentDate.end)}까지`
                                            }
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* 전체 요약 */}
                        {(arrivalDate.start || arrivalDate.end || shipmentDate.start || shipmentDate.end) && (
                            <div className="mt-6 pt-4 border-t border-gray-200">
                                <h5 className="text-sm font-medium text-gray-700 mb-2">일정 요약</h5>
                                <div className="text-sm text-gray-600 space-y-1">
                                    {arrivalDate.start && (
                                        <p>• 도착일: {arrivalDate.start && arrivalDate.end 
                                            ? `${formatDateForDisplay(arrivalDate.start)} ~ ${formatDateForDisplay(arrivalDate.end)}`
                                            : arrivalDate.start 
                                                ? `${formatDateForDisplay(arrivalDate.start)}부터`
                                                : `${formatDateForDisplay(arrivalDate.end)}까지`
                                        }</p>
                                    )}
                                    {shipmentDate.start && (
                                        <p>• 출하일: {shipmentDate.start && shipmentDate.end 
                                            ? `${formatDateForDisplay(shipmentDate.start)} ~ ${formatDateForDisplay(shipmentDate.end)}`
                                            : shipmentDate.start 
                                                ? `${formatDateForDisplay(shipmentDate.start)}부터`
                                                : `${formatDateForDisplay(shipmentDate.end)}까지`
                                        }</p>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* 액션 버튼들 */}
            <div className="flex justify-end gap-3 mt-6">
                <Button
                    onClick={onSave}
                    variant="basicNavy"
                    size="sm"
                >
                    저장
                </Button>
            </div>
        </GrayShadowBox>
    );
};

export default ProductVendorDatePicker;

